import React from 'react';

const ModalBody = ({ children }) => {
  return <div className="p-1">{children}</div>;
};

export default ModalBody;
